import React, { useState, useEffect } from 'react';
import { FaArrowRight, FaPlayCircle } from 'react-icons/fa';
import asset1 from '../assets/asset1.png';
import asset2 from '../assets/asset2.png';

const carouselImages = [
  asset1,
  asset2
];

const Hero = () => {
  const [current, setCurrent] = useState(0);

  // Automatically change image every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % carouselImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => setCurrent((prev) => (prev + 1) % carouselImages.length);
  const prevSlide = () => setCurrent((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);

  return (
    <section id="home" className="relative py-20 px-6 text-center bg-gradient-to-br from-netbernet-blue via-netbernet-black to-netbernet-black min-h-screen flex items-center">
      {/* Carousel */}
      <div className="absolute inset-0 z-0">
        <img
          src={carouselImages[current]}
          alt={`slide-${current}`}
          className="w-full h-full object-contain opacity-60 transition-all duration-700"
        />
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-30 text-white p-2 rounded-full"
        >
          &#8592;
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-30 text-white p-2 rounded-full"
        >
          &#8594;
        </button>
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-2">
          {carouselImages.map((_, idx) => (
            <span
              key={idx}
              className={`w-3 h-3 rounded-full ${idx === current ? 'bg-blue-400' : 'bg-white bg-opacity-50'}`}
            />
          ))}
        </div>
      </div>
      <div className="absolute inset-0 bg-black opacity-40 z-0"></div>
      <div className="container mx-auto relative z-10 mt-24">
        <h1 className="text-4xl md:text-6xl font-bold mb-6 text-netbernet-white leading-tight">
          Complete <span className="text-blue-400">IT Solutions</span> Provider
        </h1>
        <p className="text-xl md:text-2xl mb-10 max-w-3xl mx-auto text-gray-200">
          Based in Hyderabad, we provide comprehensive IT infrastructure, web services, and digital solutions to power your business growth.
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mb-12">
          <button className="bg-netbernet-white text-netbernet-blue px-8 py-4 rounded-lg font-semibold hover:bg-blue-100 transition-colors flex items-center gap-2">
            Get Started <FaArrowRight />
          </button>
          <button className="border-2 border-netbernet-white text-netbernet-white px-8 py-4 rounded-lg font-semibold hover:bg-netbernet-white hover:text-netbernet-blue transition-colors flex items-center gap-2">
            <FaPlayCircle /> Watch Video
          </button>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 max-w-4xl mx-auto">
          {[
            { number: '50+', label: 'Projects Completed' },
            { number: '50+', label: 'Happy Clients' },
            { number: '5+', label: 'Years Experience' },
            { number: '24/7', label: 'Support' }
          ].map((stat, index) => (
            <div key={index} className="text-center p-4 bg-netbernet-blue bg-opacity-30 rounded-lg">
              <div className="text-2xl md:text-3xl font-bold text-netbernet-white">{stat.number}</div>
              <div className="text-sm md:text-base text-gray-300">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;